import * as React from 'react';

import { ListProductionGroupProps } from '../../components/list/production-group';
import ListProduction from '../../components/list/production';

const ListProductionGroupView: React.StatelessComponent<ListProductionGroupProps> = props => {

    return (
        <div className="stack-md">

            {
                props.requiresPerformanceGroupMax || props.requiresPerformanceGroupMin ?
                    <>

                        <div className="rich-text">
                            <h2 data-demo-label="Performance Group Description">
                                {props.performanceGroup.description}
                            </h2>
                            {
                                props.requiresPerformanceGroupMin && props.cartPerformanceIdsInGroup.length < props.groupMin ?
                                    <p>{props.text.addAdditionalPerformancesForPerformanceGroupMessage
                                        .replace("{0}", (props.groupMin - props.cartPerformanceIdsInGroup.length).toString())
                                        .replace("{1}", props.performanceGroup.description)}</p>
                                    : null
                            }
                            {
                                props.requiresPerformanceGroupMax && props.cartPerformanceIdsInGroup.length == props.groupMax ?
                                    <p>{props.text.maxPerformancesForGroupMessage.replace("{0}", props.performanceGroup.description)}</p>
                                    : null
                            }
                        </div>
                    </>
                    : null
            }

            <ul className="stack-sm">
                {
                    props.performanceGroup.appProductions.map(p => <ListProduction key={`${p.productionSeasonId}`} production={p} />)
                }
            </ul>
        </div>
    )
}

export default ListProductionGroupView;